import { CompanyShareSettingsComponent } from './component/company-share-settings/company-share-settings.component';
import { CompanyShareReportComponent } from './component/company-share-report/company-share-report.component';
import { DashboardWithdrawalsComponent } from './component/dashboard-withdrawals/dashboard-withdrawals.component';
import { CreditCollectionComponent } from './component/credit-collection/credit-collection.component';
import { ConsolidatedPhoneReportComponent } from './component/consolidated-phone-report/consolidated-phone-report.component';
import { IntercompanyAdjustmentComponent } from './component/intercompany-adjustment/intercompany-adjustment.component';
import { ConsolidatedWalletComponent } from './component/consolidated-wallet/consolidated-wallet.component';
import { RiskReviewComponent } from './component/risk-review/risk-review.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ColorPickerModule } from 'ngx-color-picker';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutPostComponent } from './layout/layout-post/layout-post.component';
import { AiChatbotComponent } from './component/ai-chatbot/ai-chatbot.component';
import { FormatAiMessagePipe } from './component/ai-chatbot/format-ai-message.pipe';
import { LayoutPreComponent } from './layout/layout-pre/layout-pre.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { LoginComponent } from './component/login/login.component';
import { RegisterComponent } from './component/register/register.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { ProfileComponent } from './component/profile/profile.component';
import { PageNotFoundComponent } from './component/page-not-found/page-not-found.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminManagementComponent } from './component/admin-management/admin-management.component';
import { UnauthorizedComponent } from './component/unauthorized/unauthorized.component';
import { AdminCompanyComponent } from './component/admin-company/admin-company.component';
import { SettingGameComponent } from './component/setting-game/setting-game.component';
import { SettingBankComponent } from './component/setting-bank/setting-bank.component';
import { SettingIntegrationComponent } from './component/setting-integration/setting-integration.component';
import { WinloseComponent } from './component/winlose/winlose.component';
import { SettingBankFormComponent } from './component/setting-bank-form/setting-bank-form.component';
import { SettingIntegrateFormComponent } from './component/setting-integrate-form/setting-integrate-form.component';
import { SettingGameFormComponent } from './component/setting-game-form/setting-game-form.component';
import { SettingAdjustmentComponent } from './component/setting-adjustment/setting-adjustment.component';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { TableComponent } from './component/table/table.component';
import { UnknownPaymentComponent } from './component/unknown-payment/unknown-payment.component';
import { UnknownPaymentFormComponent } from './component/unknown-payment-form/unknown-payment-form.component';
import { PlayerComponent } from './component/player/player.component';
import { TopupWithdrawComponent } from './component/topup-withdraw/topup-withdraw.component';
import { PlayerFormComponent } from './component/player-form/player-form.component';
import { TopupWithdrawFormComponent } from './component/topup-withdraw-form/topup-withdraw-form.component';
import { AdminCompanyFormComponent } from './component/admin-company-form/admin-company-form.component';
import { AdminUserComponent } from './component/admin-user/admin-user.component';
import { AdminUserFormComponent } from './component/admin-user-form/admin-user-form.component';
import { UnknownPaymentClaimComponent } from './component/unknown-payment-claim/unknown-payment-claim.component';
import { SearchPlayerComponent } from './component/search-player/search-player.component';
import { Tablev2Component } from './component/tablev2/tablev2.component';
import { ChatComponent } from './component/chat/chat.component';
import { FrontPromotionComponent } from './component/front-promotion/front-promotion.component';
import { FrontBannerComponent } from './component/front-banner/front-banner.component';
import { FrontCategoryComponent } from './component/front-category/front-category.component';
import { FrontGamesComponent } from './component/front-games/front-games.component';
import { FrontOtherComponent } from './component/front-other/front-other.component';
import { FrontActionComponent } from './component/front-action/front-action.component';
import { FrontBannerFormComponent } from './component/front-banner-form/front-banner-form.component';
import { FrontCategoryFormComponent } from './component/front-category-form/front-category-form.component';
import { FrontGamesFormComponent } from './component/front-games-form/front-games-form.component';
import { FrontPromotionFormComponent } from './component/front-promotion-form/front-promotion-form.component';
import { FrontPageComponent } from './component/front-page/front-page.component';
import { FrontPageFormComponent } from './component/front-page-form/front-page-form.component';
import { FrontHookFormComponent } from './component/front-hook-form/front-hook-form.component';
import { FrontHookComponent } from './component/front-hook/front-hook.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { InstantNotificationComponent } from './component/instant-notification/instant-notification.component';
import { InstantNotificationFormComponent } from './component/instant-notification-form/instant-notification-form.component';
import { SettingCreditComponent } from './component/setting-credit/setting-credit.component';
import { AgentManagementComponent } from './component/agent-management/agent-management.component';
import { AgentCreditManagementComponent } from './component/agent-credit-management/agent-credit-management.component';
import { PlayerDailyComponent } from './component/player-daily/player-daily.component';
import { ClipboardModule } from 'ngx-clipboard';
import { BankReportComponent } from './component/bank-report/bank-report.component';
import { AdminReportComponent } from './component/admin-report/admin-report.component';
import { AdminReportDetailComponent } from './component/admin-report-detail/admin-report-detail.component';
import { CalculationDetailComponent } from './component/calculation-detail/calculation-detail.component';

import { MatDialogModule } from '@angular/material/dialog';
import { VoucherComponent } from './component/voucher/voucher.component';
import { VoucherFormComponent } from './component/voucher-form/voucher-form.component';
import { MassVoucherGeneratorComponent } from './component/mass-voucher-generator/mass-voucher-generator.component';
import { VoucherUsageRandomComponent } from './component/voucher-usage-random/voucher-usage-random.component';
import { DrawSectionsComponent } from './component/draw-sections/draw-sections.component';
import { DrawSectionFormComponent } from './component/draw-sections/draw-section-form/draw-section-form.component';
import { FrontSettingComponent } from './component/front-setting/front-setting.component';
import { CallReportComponent } from './component/call-report/call-report.component';
import { AccountComponent } from './component/account/account.component';
import { AccountFormComponent } from './component/account-form/account-form.component';
import { SummaryReportComponent } from './component/summary-report/summary-report.component';
import { FrontendGameComponent } from './component/frontend-game/frontend-game.component';
import { FrontendGameFormComponent } from './component/frontend-game-form/frontend-game-form.component';
import { CompanySettingComponent } from './component/company-setting/company-setting.component';
import { AutoTopupWithdrawComponent } from './component/auto-topup-withdraw/auto-topup-withdraw.component';
import { WeeklyAccountComponent } from './component/weekly-account/weekly-account.component';
import { NgbModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { GameLogComponent } from './component/game-log/game-log.component';
import { FourdkingBetHistoryComponent } from './component/fourdking-bet-history/fourdking-bet-history.component';
import { IntegrationReportComponent } from './component/integration-report/integration-report.component';
import { AgentReportPlayerDetailComponent } from './component/agent-report-player-detail/agent-report-player-detail.component';
import { SaIntegrationComponent } from './component/sa-integration/sa-integration.component';
import { AdjustmentComponent } from './component/adjustment/adjustment.component';
import { PlayerTransactionHistoryComponent } from './component/player-transaction-history/player-transaction-history.component';
import { AllGameLogComponent } from './component/all-game-log/all-game-log.component';
import { SettingIntegrationFormComponent } from './component/setting-integration-form/setting-integration-form.component';
import { NoPermissionComponent } from './component/no-permission/no-permission.component';
import { ManualTopupWithdrawComponent } from './component/manual-topup-withdraw/manual-topup-withdraw.component';
import { ManualCreatePlayerComponent } from './component/manual-create-player/manual-create-player.component';
import { ImageUploaderComponent } from './image-uploader/image-uploader.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { WhatsappComponent } from './component/whatsapp/whatsapp.component';
import { ChatChannelListComponent } from './component/chat-channel-list/chat-channel-list.component';
import { MultichatServerComponent } from './component/multichat-server/multichat-server.component';
import { WebChatSettingsComponent } from './component/web-chat-settings/web-chat-settings.component';
import { ExcelComponent } from './component/excel/excel.component';
import { PlayerProfitComponent } from './component/player-profit/player-profit.component';
import { PlayerRemoveComponent } from './component/player-remove/player-remove.component';
import { LuckyDrawModalComponent } from './component/lucky-draw-modal/lucky-draw-modal.component';
import { CommissionModalComponent } from './component/commission-modal/commission-modal.component';
import { WalletTopupWithdrawComponent } from './component/wallet-topup-withdraw/wallet-topup-withdraw.component';
import { GameLockComponent } from './component/game-lock/game-lock.component';
import { PlayerDwApprovalComponent } from './component/player-dw-approval/player-dw-approval.component';
import { PromotionLockComponent } from './component/promotion-lock/promotion-lock.component';
import { PlayerGameLogComponent } from './component/player-game-log/player-game-log.component';
import { PlayerAgentLogComponent } from './component/player-agent-log/player-agent-log.component';
import { PlayerSmsLogComponent } from './component/player-sms-log/player-sms-log.component';

import { QuillModule } from 'ngx-quill';
import { ApiGameManagementComponent } from './component/api-game-management/api-game-management.component';
import { ApiGameManagementFormComponent } from './component/api-game-management-form/api-game-management-form.component';
import { WwWalletComponent } from './component/ww-wallet/ww-wallet.component';
import { SettlementComponent } from './component/settlement/settlement.component';
import { SettlementDetailComponent } from './component/settlement-detail/settlement-detail.component';
import { ChecboxComponent } from './checbox/checbox.component';
import { PromotionCategoryComponent } from './component/promotion-category/promotion-category.component';
import { PromotionCategoryFormComponent } from './component/promotion-category-form/promotion-category-form.component';
import { SettingRollingComponent } from './component/setting-rolling/setting-rolling.component';
import { SettingRollingFormComponent } from './component/setting-rolling-form/setting-rolling-form.component';
import { DocumentComponent } from './layout/document/document.component';
import { LayoutDocumentComponent } from './layout/layout-document/layout-document.component';
import { ToastrModule } from 'ngx-toastr';
import QuillBetterTable from "quill-better-table";
import { SettingPlayerLevelFormComponent } from './component/setting-player-level-form/setting-player-level-form.component';
import { SettingPlayerLevelComponent } from './component/setting-player-level/setting-player-level.component';

import * as QuillNamespace from "quill";
import { DepositComponent } from './component/deposit/deposit.component';
import { ImagePopupComponent } from './support/image-popup/image-popup.component';
import { SmsListComponent } from './component/sms-list/sms-list.component';
import { PlayerListComponent } from './component/player-list/player-list.component';
import { TransferGameComponent } from './component/transfer-game/transfer-game.component';
import { TransferGameFormComponent } from './component/transfer-game-form/transfer-game-form.component';
import { TemplateListComponent } from './component/template-list/template-list.component';

import { TemplatePopupComponent } from './component/template-popup/template-popup.component';
import { SmsLogComponent } from './component/sms-log/sms-log.component';
import { SettingPermissionComponent } from './component/setting-permission/setting-permission.component';
import { SettingUserComponent } from './component/setting-user/setting-user.component';
import { SettingCompanyComponent } from './component/setting-company/setting-company.component';
import { SettingUserFormComponent } from './component/setting-user-form/setting-user-form.component';
import { DailySalesReportComponent } from './component/daily-sales-report/daily-sales-report.component';
import { SummaryReportV2Component } from './component/summary-report-v2/summary-report-v2.component';
import { HotGameManagementComponent } from './component/hot-game-management/hot-game-management.component';
import { HotGameManagementFormComponent } from './component/hot-game-management-form/hot-game-management-form.component';
import { AutomatedComponent } from './component/automated/automated.component';
import { AutomatedFormComponent } from './component/automated-form/automated-form.component';
import { AutomatedCustomFormComponent } from './component/automated-custom-form/automated-custom-form.component';
import { AgentReportComponent } from './component/agent-report/agent-report.component';
import { AgentWalletComponent } from './component/agent-wallet/agent-wallet.component';
import { AgentAccountComponent } from './component/agent-account/agent-account.component';
import { AgentAccountDetailComponent } from './component/agent-account/agent-account-detail.component';
import { AgentCommissionOverviewComponent } from './component/agent-commission-overview/agent-commission-overview.component';
import { LineWinlossComponent } from './component/line-winloss/line-winloss.component';
import { TopupModalComponent } from './component/topup-modal/topup-modal.component';
import { WithdrawModalComponent } from './component/withdraw-modal/withdraw-modal.component';
import { BankerGroupComponent } from './component/banker-group/banker-group.component';
import { BankerGroupFormComponent } from './component/banker-group-form/banker-group-form.component';
import { BankerGroupDetailComponent } from './component/banker-group-detail/banker-group-detail.component';
import { BankerGroupModalTopupComponent } from './component/banker-group-modal-topup/banker-group-modal-topup.component';
import { BankerGroupModalWithdrawComponent } from './component/banker-group-modal-withdraw/banker-group-modal-withdraw.component';
import { BankerGroupModalStatementComponent } from './component/banker-group-modal-statement/banker-group-modal-statement.component';
import { BankerGroupModalAddAdminComponent } from './component/banker-group-modal-add-admin/banker-group-modal-add-admin.component';
import { BankerGroupModalReferralComponent } from './component/banker-group-modal-referral/banker-group-modal-referral.component';
import { BankerGroupModalLoanComponent } from './component/banker-group-modal-loan/banker-group-modal-loan.component';
import { BankerWalletnComponent } from './component/banker-walletn/banker-walletn.component';
import { PromotionLogComponent } from './component/promotion-log/promotion-log.component';
import { PaymentGatewayLogComponent } from './component/payment-gateway-log/payment-gateway-log.component';
import { TopupPointLogComponent } from './component/topup-point-log/topup-point-log.component';
import { PlayerCreditComponent } from './component/player-credit/player-credit.component';
import { PlayerCreditReportComponent } from './component/player-credit-report/player-credit-report.component';
import { SettingPaymentGatewayComponent } from './component/setting-payment-gateway/setting-payment-gateway.component';
import { SettingPaymentGatewayFormComponent } from './component/setting-payment-gateway-form/setting-payment-gateway-form.component';
import { NotificationComponent } from './component/notification/notification.component';
import { ReferralListComponent } from './component/referral-list/referral-list.component';
import { WithdrawComponent } from './component/withdraw/withdraw.component';
import { AgentWithdrawComponent } from './component/agent-withdraw/agent-withdraw.component';
import { AgentLevelPurchaseComponent } from './component/agent-level-purchase/agent-level-purchase.component';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ExportComponent } from './component/export/export.component';
import { DomainManagementComponent } from './component/domain-management/domain-management.component';
import { DomainManagementFormComponent } from './component/domain-management-form/domain-management-form.component';
import { DomainSetupComponent } from './component/domain-setup/domain-setup.component';
import { PromotionConditionsComponent } from './component/promotion-conditions/promotion-conditions.component';
import { ManageSupplierGameComponent } from './component/manage-supplier-game/manage-supplier-game.component';
import { FrontPartnershipComponent } from './component/front-partnership/front-partnership.component';
import { FrontPartnershipFormComponent } from './component/front-partnership-form/front-partnership-form.component';
import { ReferralTreeModalComponent } from './component/referral-tree-modal/referral-tree-modal.component';
import { NoScrollWheelDirective } from './directive/no-scroll-wheel.directive';
import { DownlineDepositWithdrawModalComponent } from './component/downline-deposit-withdraw-modal/downline-deposit-withdraw-modal.component';

let Quill: any = QuillNamespace.default;

Quill.register({
  "modules/better-table": QuillBetterTable
}, true);
let tableHandeler = function () {
  let tableModule = this.quill.getModule("better-table");
  tableModule.insertTable(2, 2);
};

function _quillGetCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function _quillGetCompanyUuid(): string | null {
  const match = window.location.pathname.match(/\/lo\/([^\/]+)/);
  return match ? match[1] : null;
}

async function _quillUpload(base64: string, endpoint: string): Promise<any> {
  const resp = await fetch(environment.url + endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ file: base64, user_uuid: _quillGetCookie('uuid'), company_uuid: _quillGetCompanyUuid() })
  });
  return resp.json();
}

let quillImageHandler = function (this: any) {
  const quill = this.quill;
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/png,image/jpeg,image/gif,image/webp');
  input.click();
  input.onchange = () => {
    const file = (input as any).files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      const data = await _quillUpload(e.target.result, '/admin/file-upload');
      if (data?.status && data?.path) {
        const range = quill.getSelection(true);
        quill.insertEmbed(range.index, 'image', data.path);
        quill.setSelection(range.index + 1);
      }
    };
    reader.readAsDataURL(file);
  };
};

let quillVideoHandler = function (this: any) {
  const quill = this.quill;
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'video/mp4,video/ogg,video/webm');
  input.click();
  input.onchange = () => {
    const file = (input as any).files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      const data = await _quillUpload(e.target.result, '/admin/file-upload/video');
      if (data?.status && data?.path) {
        const range = quill.getSelection(true);
        quill.clipboard.dangerouslyPasteHTML(
          range.index,
          `<video controls src="${data.path}" style="max-width:100%"></video>`
        );
        quill.setSelection(range.index + 1);
      }
    };
    reader.readAsDataURL(file);
  };
};
@NgModule({
  declarations: [
    IntercompanyAdjustmentComponent,
    AppComponent,
    LayoutPostComponent,
    LayoutPreComponent,
    DashboardComponent,
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    ProfileComponent,
    PageNotFoundComponent,
    SidebarComponent,
    AdminManagementComponent,
    UnauthorizedComponent,
    AdminCompanyComponent,
    SettingGameComponent,
    SettingBankComponent,
    SettingIntegrationComponent,
    WinloseComponent,
    SettingBankFormComponent,
    SettingIntegrateFormComponent,
    SettingGameFormComponent,
    SettingAdjustmentComponent,
    TableComponent,
    UnknownPaymentComponent,
    UnknownPaymentFormComponent,
    PlayerComponent,
    TopupWithdrawComponent,
    PlayerFormComponent,
    TopupWithdrawFormComponent,
    AdminCompanyFormComponent,
    AdminUserComponent,
    AdminUserFormComponent,
    UnknownPaymentClaimComponent,
    SearchPlayerComponent,
    Tablev2Component,
    ChatComponent,
    FrontPromotionComponent,
    FrontBannerComponent,
    FrontCategoryComponent,
    FrontGamesComponent,
    FrontOtherComponent,
    FrontActionComponent,
    FrontBannerFormComponent,
    FrontCategoryFormComponent,
    FrontGamesFormComponent,
    FrontPromotionFormComponent,
    FrontPageComponent,
    FrontPageFormComponent,
    FrontHookFormComponent,
    FrontHookComponent,
    InstantNotificationComponent,
    InstantNotificationFormComponent,
    SettingCreditComponent,
    AgentManagementComponent,
    AgentCreditManagementComponent,
    PlayerDailyComponent,
    BankReportComponent,
    AdminReportComponent,
    AdminReportDetailComponent,
    CalculationDetailComponent,
    VoucherComponent,
    VoucherFormComponent,
    MassVoucherGeneratorComponent,
    VoucherUsageRandomComponent,
    DrawSectionsComponent,
    DrawSectionFormComponent,
    FrontSettingComponent,
    CallReportComponent,
    AccountComponent,
    AccountFormComponent,
    SummaryReportComponent,
    FrontendGameComponent,
    FrontendGameFormComponent,
    CompanySettingComponent,
    AutoTopupWithdrawComponent,
    WeeklyAccountComponent,
    GameLogComponent,
    FourdkingBetHistoryComponent,
    IntegrationReportComponent,
    AgentReportPlayerDetailComponent,
    SaIntegrationComponent,
    AdjustmentComponent,
    PlayerTransactionHistoryComponent,
    AllGameLogComponent,
    SettingIntegrationFormComponent,
    NoPermissionComponent,
    ManualTopupWithdrawComponent,
    ConsolidatedWalletComponent,
    ConsolidatedPhoneReportComponent,
    RiskReviewComponent,
    ManualCreatePlayerComponent,
    WhatsappComponent,
    ChatChannelListComponent,
    MultichatServerComponent,
    WebChatSettingsComponent,
    ExcelComponent,
    PlayerProfitComponent,
    PlayerRemoveComponent,
    LuckyDrawModalComponent,
    CommissionModalComponent,
    WalletTopupWithdrawComponent,
    GameLockComponent,
    PlayerDwApprovalComponent,
    PlayerGameLogComponent,
    PlayerAgentLogComponent,
    PlayerSmsLogComponent,
    PromotionLockComponent,
    ApiGameManagementComponent,
    ApiGameManagementFormComponent,
    WwWalletComponent,
    SettlementComponent,
    SettlementDetailComponent,
    ChecboxComponent,
    PromotionCategoryComponent,
    PromotionCategoryFormComponent,
    SettingRollingComponent,
    SettingRollingFormComponent,
    DocumentComponent,
    LayoutDocumentComponent,
    SettingPlayerLevelFormComponent,
    SettingPlayerLevelComponent,
    DepositComponent,
    ImagePopupComponent,
    SmsListComponent,
    PlayerListComponent,
    TransferGameComponent,
    TransferGameFormComponent,
    TemplateListComponent,
    TemplatePopupComponent,
    SmsLogComponent,
    SettingPermissionComponent,
    SettingUserComponent,
    SettingCompanyComponent,
    SettingUserFormComponent,
    DailySalesReportComponent,
    SummaryReportV2Component,
    HotGameManagementComponent,
    HotGameManagementFormComponent,
    AutomatedComponent,
    AutomatedFormComponent,
    AutomatedCustomFormComponent,
    AgentReportComponent,
    AgentWalletComponent,
    AgentAccountComponent,
    AgentAccountDetailComponent,
    AgentCommissionOverviewComponent,
    LineWinlossComponent,
    TopupModalComponent,
    WithdrawModalComponent,
    BankerGroupComponent,
    BankerGroupFormComponent,
    BankerGroupDetailComponent,
    BankerGroupModalTopupComponent,
    BankerGroupModalWithdrawComponent,
    BankerGroupModalStatementComponent,
    BankerGroupModalAddAdminComponent,
    BankerGroupModalReferralComponent,
    BankerGroupModalLoanComponent,
    BankerWalletnComponent,
    PromotionLogComponent,
    PaymentGatewayLogComponent,
    TopupPointLogComponent,
    PlayerCreditComponent,
    PlayerCreditReportComponent,
    SettingPaymentGatewayComponent,
    SettingPaymentGatewayFormComponent,
    NotificationComponent,
    ReferralListComponent,
    WithdrawComponent,
    AgentWithdrawComponent,
    AgentLevelPurchaseComponent,
    ExportComponent,
    DomainManagementComponent,
    DomainManagementFormComponent,
    DomainSetupComponent,
    PromotionConditionsComponent,
    ManageSupplierGameComponent,
    FrontPartnershipComponent,
    FrontPartnershipFormComponent,
    AiChatbotComponent,
    FormatAiMessagePipe,
    ReferralTreeModalComponent,
    NoScrollWheelDirective,
    DownlineDepositWithdrawModalComponent,
  ],
  imports: [
    CompanyShareSettingsComponent, CompanyShareReportComponent,
    CreditCollectionComponent,
    DashboardWithdrawalsComponent,
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    MatToolbarModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    AngularEditorModule,
    ClipboardModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    NgbModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgSelectModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    DragDropModule,
    QuillModule.forRoot({
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean', 'link', 'table'],
            ['image', 'video']
          ],
          handlers: {
            table: tableHandeler,
            image: quillImageHandler,
            video: quillVideoHandler
          }
        },
        table: false,
        "better-table": {
          operationMenu: {
            items: {
              insertColumnRight: false,
              insertColumnLeft: {
                text: 'Insert Column',
              },
              insertRowUp: {
                text: 'Insert Row Up',
              },
              insertRowDown: {
                text: 'Insert Row Down',
              },
              mergeCells: true,
              unmergeCells: true,
              deleteColumn: {
                text: 'Delete Selected Column',
              },
              deleteRow: {
                text: 'Delete Selected Row',
              },
              deleteTable: {
                text: 'Delete Table',
              }
            },
            color: {
              colors: [
                "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
                "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
                "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
                "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
                "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"
              ],
              text: "Background Colors"
            }
          }
        },
        keyboard: {
          bindings: QuillBetterTable.keyboardBindings
        }
      },
    }),
    ImageUploaderComponent
  ],
  providers: [
    CookieService,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    { provide: MAT_DATE_LOCALE, useValue: 'en-MY' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
